var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"big-card"},[_c('div',{staticClass:"icon-box flex-start-center"},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.index))]),_c('span',{staticClass:"point"},[_vm._v(".")]),_c('span',{staticClass:"card-title"},[_vm._v("打气球游戏测评")])]),_c('div',{staticClass:"margin-top"},[(_vm.gameQi.gameIsFinish === 1)?[_c('DescribeData',{staticClass:"margin-bottom",attrs:{"describe":{
            label: '候选人认知能力：',
            color: '#5654DC',
            text: _vm.tag,
            desc: _vm.gameQi.balloonData.cognitiveAbilityContent
          }}}),_c('DescribeData',{attrs:{"describe":{
            label: _vm.other ? '候选人风险偏好' : '候选人风险偏好：',
            color: '#5654DC',
            text: _vm.other ? '' : _vm.gameQi.balloonData.riskAppetiteType,
            desc: _vm.other
              ? '作答结果无效，态度可能有问题，该游戏测评结果不具备参考性'
              : _vm.gameQi.balloonData.riskAppetiteContent
          }}})]:_c('div',{staticClass:"noanswer-module",staticStyle:{"box-sizing":"border-box"}},[_c('i',{staticClass:"iconfont iconfont-color"},[_vm._v("")]),_vm._v(" 候选人未作答 ")])],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }